import React, { useState, useCallback } from "react";
import { Auth } from "aws-amplify";
import { TopBar } from "@shopify/polaris";
import { LockMajor, CircleLeftMajor } from "@shopify/polaris-icons";
import { CognitoUserInterface } from "@aws-amplify/ui-components";
import { MainFrameContext } from "../contexts/MainFrameContext";
import MainFrameContextType from "../../types/MainFrameContextType";
import Routes from "../../config/api";
import ReactGA from "react-ga4";
import {useSelector} from "react-redux";
import {userIsDocCollector} from "../../helpers/users";

interface LayoutProps {
    user: CognitoUserInterface;
}

export default function Header({ user }: LayoutProps) {
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const [name, setName] = useState("");
    const { toggleMobileNavigationActive } = React.useContext(
        MainFrameContext
    ) as MainFrameContextType;
    const isDocumentCollector: boolean = useSelector((state: any) => userIsDocCollector(state));

    React.useEffect(() => {
        if (user) {
            if (user.attributes) {
                setName(user.attributes["name"]);
            }
        }
    }, [user]);

    /**
     * Logout user to login screen
     */
    const handleLogout = useCallback(async () => {
        await Auth.signOut();
        ReactGA.event({
            category: "User Action",
            action: "logged out",
            value: 0
        });

        localStorage.clear();
        window.location.assign(
            `${Routes.authUrlProtocol}://${process.env.REACT_APP_AUTH_URL}/logout?redirect=${window.location.href}`
        );

    }, []);

    /**
     * Return initials for user name
     */
    const getUserInitials = () => {
        if (name) {
            const splitName = name.split(" ");
            if (splitName.length === 2) {
                return splitName[0][0] + splitName[1][0];
            } else if (splitName.length === 3) {
                return splitName[0][0] + splitName[2][0];
            }
        }
        return "";
    };

    const toggleIsUserMenuOpen = useCallback(
        () => setIsUserMenuOpen((isUserMenuOpen) => !isUserMenuOpen),
        []
    );

    const userMenuMarkup = (
        <TopBar.UserMenu
            actions={[
                {
                    items: [
                        {
                            content: "Change Password",
                            icon: LockMajor,
                            onAction: () => {
                                window.location.assign(
                                    `${Routes.authUrlProtocol}://${process.env.REACT_APP_AUTH_URL}/reset-password?redirect=${window.location.href}`
                                );
                            }
                        }
                    ]
                },
                {
                    items: [
                        {
                            content: "Logout",
                            icon: CircleLeftMajor,
                            onAction: handleLogout
                        }
                    ]
                }
            ]}
            name={name}
            initials={getUserInitials()}
            open={isUserMenuOpen}
            onToggle={toggleIsUserMenuOpen}
        />
    );

    return (
        <div>
            {
                isDocumentCollector ?
                    <TopBar/>
                :
                    <TopBar
                        userMenu={userMenuMarkup}
                        showNavigationToggle
                        onNavigationToggle={toggleMobileNavigationActive}
                    />
            }
        </div>
    );
}
